import { filter } from "lodash";

import { useEffect, useState } from "react";

import {
  Link as RouterLink,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  IconButton,
} from "@mui/material";

import SearchNotFound from "src/components/NotFound/SearchNotFound";

import Label from "src/components/Label";
import { UserListHead } from "src/components/_dashboard/user";

import { CircularProgress } from "@mui/material";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import { Pages } from "@mui/icons-material";
import moment from "moment";
import CustomConfirmation from "src/components/ModalPopover/Confirmation";
import UserListToolbars from "src/components/_dashboard/user/UserListToolbars";
import CustomPopoverSection from "src/components/MenuOption/CustomPopoverSection";
import {
  deleteForm,
  deleteFormForSpecificMember,
  getAllFormsList,
  getAllMembersFormsAgainstProgramsList,
} from "src/DAL/SendFormTemplate/sendFormTemplate";
import { convertToTitleCase } from "src/utils/convertHtml";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { Icon } from "@iconify/react";
import roundFilterList from "@iconify/icons-ic/round-filter-list";

//
// import USERLIST from "../_mocks_/user";

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: "action", label: "Action", alignRight: false },

  { id: "number", label: "#", alignRight: false },

  // { id: "title", label: " Title", alignRight: false },
  {
    id: "send_to",
    label: "Member",
    alignRight: false,
  },
  {
    id: "submitted_at",
    label: "Submitted At",
    alignRight: false,
  },
  {
    id: "submission_status",
    label: "Submission Status",
    alignRight: false,
  },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) =>
        _user?.fullName?.toLowerCase().indexOf(query?.toLowerCase()) !== -1,
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));
let dumyData = [
  {
    id: 1,
    title: "Basic Information",
    description:
      "Cycling can help to protect you from serious diseases such as stroke, heart attack, some cancers, depression, diabetes, obesity and arthritis.",
  },
];
export default function UserFormAgainstProgram() {
  const navigate = useNavigate();
  const { state, pathname } = useLocation();
  const { fId, tId, id } = useParams();
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("number");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(500);
  const [open, setOpen] = useState(false);
  const [questionData, setQuestionData] = useState([]);
  const [userList, setUserList] = useState(dumyData);
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [deleteDoc, setDeleteDoc] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [member, setData] = useState([]);

  const searchFunction = () => {
    setPage(0);
    getFormTemListing();
  };

  const handleRequestSort = (event, property) => {};

  const getFormTemListing = async (filterData) => {
    setIsLoading(true);
    let postData = {
      search: filterName,
      batch: fId,
      program: id,
      form_template: tId,
    };
    try {
      setIsLoading(true);
      const result = await getAllMembersFormsAgainstProgramsList(
        page,
        rowsPerPage,
        postData,
      );
      if (result.code === 200) {
        setData(result.forms);
        setIsLoading(false);
        setUserList(result.forms);
        setIsLoading(false);
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
        setIsLoading(false);
      }
    } catch (error) {}
  };
  const handleEdit = (value) => {
    navigate(`/forms-edit-forms/${value.form_slug}`, {
      state: value,
    });
  };
  const handlePreview = (value) => {
    if (pathname.match("/programmes/")) {
      navigate(`/programmes/forms-preview/${value.form_slug}`, {
        state: value,
      });
    } else {
      navigate(`/forms-preview/${value.form_slug}`, {
        state: value,
      });
    }
  };

  const handleAgreeDelete = (value) => {
    setDeleteDoc(value);
    setOpenDelete(true);
  };
  const handleDelete = async () => {
    setOpenDelete(false);
    setIsLoading(true);
    const result = await deleteFormForSpecificMember(deleteDoc._id);
    if (result.code === 200) {
      getFormTemListing();
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const Capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };
  const handleNavigate = () => {
    navigate(`/forms-send-forms`);
  };
  const handleNavigateMember = (e) => {
    navigate(`/coach/add-coach`);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - userList.length) : 0;

  const filteredUsers = applySortFilter(
    userList,
    getComparator(order, orderBy),
    filterName,
  );

  useEffect(() => {
    getFormTemListing();
  }, [Pages, rowsPerPage]);

  const MENU_OPTIONS1 = [
    {
      label: "Edit",
      icon: "akar-icons:edit",
      handleClick: handleEdit,
    },
    {
      label: "Preview",
      icon: "pajamas:eye",

      handleClick: handlePreview,
    },
    {
      label: "Delete",
      icon: "ant-design:delete-twotone",
      handleClick: handleAgreeDelete,
    },
    // {
    //   label: "Preview",
    //   icon: "pajamas:eye",

    //   handleClick: handlePreview,
    // },
  ];
  const MENU_OPTIONS2 = [
    {
      label: "Preview",
      icon: "pajamas:eye",

      handleClick: handlePreview,
    },
    {
      label: "Delete",
      icon: "ant-design:delete-twotone",
      handleClick: handleAgreeDelete,
    },
    // {
    //   label: "Preview",
    //   icon: "pajamas:eye",

    //   handleClick: handlePreview,
    // },
  ];
  const isUserNotFound = filteredUsers.length === 0;
  if (isLoading == true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <>
      <CustomConfirmation
        openDelete={openDelete}
        setOpenDelete={setOpenDelete}
        title={"Are you sure you want to delete ?"}
        handleAgree={handleDelete}
      />

      <div className="container">
        <IconButton onClick={() => navigate(-1)}>
          <ArrowBackIcon />
        </IconButton>
        <div className="row mt-2">
          <div className="col-lg-8 col-sm-12">
            <h2>{state?.title} </h2>
          </div>
          <div className="col-lg-8 col-sm-12">
            <p>{state?.send_to?.name} </p>
          </div>
          <span className="col-lg-8 col-sm-12 date-color">
            {moment(state?.createdAt).format("ddd, MMM DD, YYYY")}
          </span>
        </div>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          {/* <Typography variant="h4" gutterBottom>
              Goal Statement
            </Typography> */}
        </Stack>

        <Card style={{ overflowX: "auto" }}>
          <UserListToolbars
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            onSearch={() => searchFunction()}
          />

          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <UserListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={userList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
                // onSelectAllClick={handleSelectAllClick}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, i) => {
                    const {
                      id,
                      name,
                      status,
                      title,
                      description,
                      date,
                      send_to,
                      submission_status,
                      receiver_type,
                      createdAt,
                      submitted_at,
                    } = row;
                    const isItemSelected = selected.indexOf(name) !== -1;

                    return (
                      <TableRow
                        hover
                        key={id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell>
                          {
                            <CustomPopoverSection
                              menu={MENU_OPTIONS2}
                              data={row}
                            />
                          }
                        </TableCell>
                        <TableCell align="left">
                          {page * rowsPerPage + (i + 1)}
                        </TableCell>

                        <TableCell>
                          <Stack
                            direction="column"
                            alignItems="start"
                            spacing={0}
                          >
                            <Typography variant="subtitle2" noWrap>
                              {send_to?.first_name
                                ? send_to?.first_name + " " + send_to?.last_name
                                : "N/A"}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          className="text-nowrap"
                        >
                          {submitted_at
                            ? moment(submitted_at).format("ddd, MMM DD, YYYY")
                            : "N/A"}
                        </TableCell>
                        <TableCell>
                          <Label
                            variant="ghost"
                            color={
                              (submission_status === "submitted" &&
                                "success") ||
                              "warning"
                            }
                          >
                            {submission_status === "submitted"
                              ? "Submitted"
                              : "Pending"}
                          </Label>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>

          <TablePagination
            rowsPerPageOptions={[50, 100, 150, 500]}
            component="div"
            count={userList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </div>
    </>
  );
}
